import useAuth from "./useAuth";
import { CouncilDTO, TblCouncil } from "@/types/user.type";
import { IUser, UserDTO } from "@/types/user.type";

function councilDtoToTblCouncil(c: CouncilDTO | { id: string; councilCode: string; name: string; councilProfileDocumentPath?: string | null; registrarName?: string | null }): TblCouncil {
  const result = {
    id: c.id,
    councilCode: c.councilCode,
    name: c.name,
    councilName: c.name,
    councilProfileDocumentPath: c.councilProfileDocumentPath ?? "",
    amount: 0,
    status: "",
    ...("registrarName" in c && { registrarName: (c as any).registrarName }),
  };
  return result as TblCouncil;
}

export function useUserCouncil(user?: IUser | UserDTO | null): TblCouncil | undefined {
  const { user: authUser } = useAuth();
  const u = user ?? authUser;
  if (!u) return undefined;

  const usercouncil = (u as IUser & { usercouncil?: TblCouncil[] }).usercouncil;
  if (Array.isArray(usercouncil) && usercouncil.length > 0) {
    const first = usercouncil[0];
    const hasCouncilName = "councilName" in first && first.councilName !== undefined;
    const result = hasCouncilName
      ? first
      : councilDtoToTblCouncil(first as CouncilDTO);

    // Debug: registrarName flow
    if (process.env.NODE_ENV === "development") {
      console.log("[useUserCouncil] usercouncil[0]:", {
        raw: first,
        registrarNameInRaw: (first as any)?.registrarName,
        councilNameInRaw: (first as any)?.councilName,
        nameInRaw: (first as any)?.name,
        hasCouncilName,
        resultRegistrarName: result?.registrarName,
      });
    }
    return result;
  }

  const councils = (u as UserDTO & { councils?: CouncilDTO[] }).councils;
  if (Array.isArray(councils) && councils.length > 0) {
    return councilDtoToTblCouncil(councils[0]);
  }

  return undefined;
}
